import React from 'react';
import FormControlCaption from "../../formComponents/FormControlCaption";
import cl from "./SurveyBlock.module.css";
import FormBlock from "../../formComponents/FormBlock";

const SurveyBlock = ({initData}) => {
    return (
        <FormBlock>
            <div>
                <FormControlCaption text="Данные отправителя"/>
                {renderUserField("uid", initData.user_id)}
                {renderUserField("e-mail", initData.user_email)}
                {renderUserField("дата", extractDate(initData))}
            </div>
        </FormBlock>
    );
};

function renderUserField(label, value) {
    return <p className={cl.userFieldRow}><span className={cl.userFieldLabel}>{label}:</span> <span
        className={cl.userFieldValue}>{value}</span></p>
}

function extractDate(item) {
    if (!item || !item.created_at)
        return "";

    // "2026-07-09T21:21:22.493691+03:00"
    const regex = /^(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d:\d\d)/;
    const match = regex.exec(item.created_at);
    if (!match)
        return "";

    return `${match[3]}.${match[2]}.${match[1]} ${match[4]}`;
}

export default SurveyBlock;